import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='threeDsAppRequestorUrl' subtitle='String' mdxType="Item">
      <p>{`Set the `}<a parentName="p" {...{
          "href": "https://developer.apple.com/ios/universal-links/"
        }}>{`iOS Universal Link`}</a>{` that's used to call your app after an `}<strong parentName="p">{`out-of-band (OOB)`}</strong>{` authentication.
Supported in 3D Secure protocol versions 2.2.0 and after.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      